import React from 'react';
import NotebookNav from './NotebookNav/Small';
import { ScrollView } from '../../components/ui';

const NotebookLayoutS: React.FC = ({ children }) => (
  <div className="fixed absolute--fill flex flex-column" data-testid="notebook-layout-scrollview">
    <NotebookNav />
    <ScrollView className="ph3">{children}</ScrollView>
  </div>
);

export default NotebookLayoutS;
